import Affiliates from './Affiliates';

export default Affiliates;
